import updateCalendarEvent from '../actions/updateCalendarEvent';
import { getSurfaceStore } from '../store/surfaceStore';
import { getSelectedCalendars } from 'owa-calendar-surface-calendars-store';
import { addCalendarItems, removeCalendarItems } from 'owa-calendar-surface-dategrid';
import { orchestrator } from 'satcheljs';
import {
    calendarEventsAdded,
    calendarEventsRemoved,
    calendarEventsRemovedMatchingFilter,
    calendarEventUpdated,
} from 'owa-calendar-events-store';
import { getCalendarFolderId } from 'owa-calendar-cache';
import { isFTDFSeriesMaster, isSeriesMaster } from 'owa-calendar-event-capabilities';

export const calendarEventsAddedOrchestrator = orchestrator(calendarEventsAdded, actionMessage => {
    const { eventsAdded } = actionMessage;

    // from the events added to cache, only add those events to the surface which belong to selected calendars
    const eventsToAddToSurface = eventsAdded.filter(event => {
        const seriesMaster = isSeriesMaster(event) || isFTDFSeriesMaster(event);
        return (
            !seriesMaster &&
            getSelectedCalendars().some(c => getCalendarFolderId(c) == event.ParentFolderId.Id)
        );
    });

    addCalendarItems(eventsToAddToSurface, getSurfaceStore());
});

orchestrator(calendarEventsRemoved, actionMessage => {
    const { eventsRemoved } = actionMessage;
    removeCalendarItems(eventsRemoved && eventsRemoved.map(e => e.ItemId.Id), getSurfaceStore());
});

orchestrator(calendarEventsRemovedMatchingFilter, actionMessage => {
    const { removePredicate } = actionMessage;
    const surfaceStore = getSurfaceStore();
    const eventsToRemove = surfaceStore.calendarItems.filter(removePredicate);
    removeCalendarItems(eventsToRemove && eventsToRemove.map(e => e.ItemId.Id), surfaceStore);
});

orchestrator(calendarEventUpdated, actionMessage => {
    const { eventUpdated } = actionMessage;
    updateCalendarEvent(eventUpdated);
});
